import pricingPlans from "../../constants/pricingPlans";
import styles from "../../constants/styles";
import PricingPlanTile from "./PricingPlanTile";

const Pricing = () => {
  return (
    <section
      id="pricingSection"
      className="flex flex-col items-center space-y-4"
    >
      <h2 className={styles.secondaryHeading}>Pricing</h2>
      <span className={styles.standardText}>
        You can upgrade inside the chrome extension.
      </span>

      <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-rows gap-4 mx-4">
        {pricingPlans.map(plan => {
          return (
            <PricingPlanTile
              key={plan.planName}
              planName={plan.planName}
              price={plan.price}
              features={plan.features}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Pricing;
